// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.animate-right {
  visibility: visible;
  animation: animateright 0.4s;
}
@keyframes animateright {
  from {
    right: -300px;
    opacity: 0;
  }
  to {
    right: 0;
    opacity: 1;
  }
}

.animate-right-close {
  visibility: hidden;
  opacity: 0;
  transition: visibility 0s linear 0.33s, opacity 0.33s linear;
}
@keyframes animaterightclose {
  from {
    left: 0px;
    opacity: 0;
  }
  to {
    right: -300px;
    opacity: 1;
  }
}

.card {
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);
}

.sideBarContainer{
  text-align: center;
}

.bar-block .bar-item {
  width: 100%;
  display: block;
  background-color: #fff;
  border-top: 1px solid rgba(74,92,96,.45);
  color: #0c9abe;
  padding: 8px 16px;
  text-align: right;
  font-family: NunitoSans-Bold,sans-serif;
  font-size: 18px;
  border: none;
  white-space: normal;
  float: none;
  outline: 0;
}
.bar-block.center .bar-item {
  text-align: center;
}
.block {
  display: block;
  width: 100%;
}
.sidebar {
  height: 100%;
  width: 40%;
  right: 0;
  top: 0px;
  background-color: #fff;
  position: fixed !important;
  z-index: 1000;
  overflow: auto;
}

.backGroud-sidebar {
  background: rgba(#000, .4);
  background-color: rgba(050, 050, 050, 0.7);
  content: '';
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0; right: 0; bottom: 0; left: 0;
  z-index: 999;
}

/* @media screen and (max-width: 320px) {
  .sidebar {
    width: 100%;
    position: fixed;
  }
} */

@media screen and (max-width: 1200px) {
  .sidebar {
    width: 100%;
    position: fixed;
  }
}
`, "",{"version":3,"sources":["webpack://./src/app/shared/component/side-bar/side-bar.component.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;EACnB,4BAA4B;AAC9B;AACA;EACE;IACE,aAAa;IACb,UAAU;EACZ;EACA;IACE,QAAQ;IACR,UAAU;EACZ;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,4DAA4D;AAC9D;AACA;EACE;IACE,SAAS;IACT,UAAU;EACZ;EACA;IACE,aAAa;IACb,UAAU;EACZ;AACF;;AAEA;EACE,6EAA6E;AAC/E;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,wCAAwC;EACxC,cAAc;EACd,iBAAiB;EACjB,iBAAiB;EACjB,uCAAuC;EACvC,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,WAAW;AACb;AACA;EACE,YAAY;EACZ,UAAU;EACV,QAAQ;EACR,QAAQ;EACR,sBAAsB;EACtB,0BAA0B;EAC1B,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,0CAA0C;EAC1C,WAAW;EACX,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM,EAAE,QAAQ,EAAE,SAAS,EAAE,OAAO;EACpC,YAAY;AACd;;AAEA;;;;;GAKG;;AAEH;EACE;IACE,WAAW;IACX,eAAe;EACjB;AACF","sourcesContent":[".animate-right {\n  visibility: visible;\n  animation: animateright 0.4s;\n}\n@keyframes animateright {\n  from {\n    right: -300px;\n    opacity: 0;\n  }\n  to {\n    right: 0;\n    opacity: 1;\n  }\n}\n\n.animate-right-close {\n  visibility: hidden;\n  opacity: 0;\n  transition: visibility 0s linear 0.33s, opacity 0.33s linear;\n}\n@keyframes animaterightclose {\n  from {\n    left: 0px;\n    opacity: 0;\n  }\n  to {\n    right: -300px;\n    opacity: 1;\n  }\n}\n\n.card {\n  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.16), 0 2px 10px 0 rgba(0, 0, 0, 0.12);\n}\n\n.sideBarContainer{\n  text-align: center;\n}\n\n.bar-block .bar-item {\n  width: 100%;\n  display: block;\n  background-color: #fff;\n  border-top: 1px solid rgba(74,92,96,.45);\n  color: #0c9abe;\n  padding: 8px 16px;\n  text-align: right;\n  font-family: NunitoSans-Bold,sans-serif;\n  font-size: 18px;\n  border: none;\n  white-space: normal;\n  float: none;\n  outline: 0;\n}\n.bar-block.center .bar-item {\n  text-align: center;\n}\n.block {\n  display: block;\n  width: 100%;\n}\n.sidebar {\n  height: 100%;\n  width: 40%;\n  right: 0;\n  top: 0px;\n  background-color: #fff;\n  position: fixed !important;\n  z-index: 1000;\n  overflow: auto;\n}\n\n.backGroud-sidebar {\n  background: rgba(#000, .4);\n  background-color: rgba(050, 050, 050, 0.7);\n  content: '';\n  height: 100%;\n  width: 100%;\n  position: fixed;\n  top: 0; right: 0; bottom: 0; left: 0;\n  z-index: 999;\n}\n\n/* @media screen and (max-width: 320px) {\n  .sidebar {\n    width: 100%;\n    position: fixed;\n  }\n} */\n\n@media screen and (max-width: 1200px) {\n  .sidebar {\n    width: 100%;\n    position: fixed;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
